import { unflattenData } from "../../helpers/SurveyJSHelpers";
import { IClientData } from "../../models/ClientData";
import { LanderV2CampaignConfig } from "../Campaigns/Schemas/LanderV2/types";
import { resolveLanderV2Headline } from "./resolveLanderV2Headline";

/** The visitor's answers from the session draft; keys under "lander:" hold each lander's progress and are never sent. */
export function draftAnswers(draft: Record<string, unknown>) {
  return unflattenData(Object.fromEntries(Object.entries(draft).filter(([key]) => !key.startsWith("lander:"))));
}

/** The complete lead, always built from the whole draft and never from a single step. */
export function buildLeadPayload(
  draft: Record<string, any>,
  landingUrl: string,
  campaign: LanderV2CampaignConfig
): IClientData {
  const { retirementMonth, retirementYear, ...answers } = draftAnswers(draft) as IClientData & {
    retirementMonth?: string;
    retirementYear?: string;
  };
  const headline = resolveLanderV2Headline(campaign, new URL(landingUrl).search);

  return {
    ...answers,
    annuity: answers.annuity
      ? { ...answers.annuity, taxFreeCashTypeID: answers.annuity.taxFreeCashTypeID || "5907" }
      : answers.annuity,
    trackingUrlId: landingUrl,
    landingPageHeading1: headline.heading,
    landingPageHeading2: headline.subheading,
    landingPageTheme: campaign.landingPageTheme,
    landingPageVariation: campaign.landingPageVariation,
    landingPageVersion: campaign.landingPageVersion,
    sessionId: draft.sessionId,
  };
}
